var _g, _g2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 62,
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.0386212
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4523 0.873047C47.259 0.873047 60.9047 14.5401 60.9047 31.373C60.9047 48.206 47.259 61.873 30.4523 61.873C13.6457 61.873 0 48.206 0 31.373C0 14.5401 13.6457 0.873047 30.4523 0.873047Z",
    fill: "#1AA773"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.990827
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4535 12.2812C40.9053 12.2812 49.3913 20.7806 49.3913 31.2487C49.3913 41.7169 40.9053 50.2162 30.4535 50.2162C20.0017 50.2162 11.5156 41.7169 11.5156 31.2487C11.5156 20.7806 20.0017 12.2812 30.4535 12.2812Z",
    fill: "#1AA773"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1934 30.4094L27.834 36.0588C27.834 36.0588 34.8905 28.9912 37.2588 26.6191",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsSuccess);
export default __webpack_public_path__ + "static/media/isSuccess.f7b4ced74045041412a62f33ba1999c3.svg";
export { ForwardRef as ReactComponent };